var swiper = new Swiper(".imgGallery", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  mousewheel: {
    forceToAxis: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 4,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 4,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 4,
    },
  },
});
